import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-arrow-navigation/jb-arrow-navigation.css.ts
var jb_arrow_navigation_css_default = i`:host{align-items:center;block-size:40px;display:flex}button{appearance:none;background:rgba(0,0,0,0);border:0;display:inline;padding:0}.arrow-navigation{align-items:center;display:flex;gap:var(--spacing-s)}`;

export {
  jb_arrow_navigation_css_default
};
